/* @flow */
import liferay from 'services/api';
import type { AsyncAction } from 'types/index';

const onFailure = (error: Object) => console.warn(error);

const fetchCategories = (): AsyncAction => {
  return {
    type: 'FETCH_CATEGORIES_REQUEST',
    promise: liferay.categories.find(),
    meta: { onFailure },
  };
};

export default {
  fetchCategories,
};
